import { Stack, Text } from "@mantine/core"
import { Trans, useTranslation } from "react-i18next"

import { getStubInvitingCompanyName } from "~/pages/SupplierPortal/Onboarding/welcomeStep/welcomeStep.stub"

const welcomeParagraphStyle = {
  lineHeight: 1.6,
} as const

export const WelcomeStep = () => {
  const { t } = useTranslation("supplier")
  const invitingCompanyName = getStubInvitingCompanyName()

  return (
    <Stack gap="var(--tfg-organism-padding-y)">
      <Text component="p" m={0} size="sm" style={welcomeParagraphStyle}>
        {t("onboarding.welcome.intro")}
      </Text>
      <Text component="p" m={0} size="sm" style={welcomeParagraphStyle}>
        <Trans
          components={{ strong: <strong /> }}
          i18nKey="onboarding.welcome.invitation"
          ns="supplier"
          t={t}
          values={{ invitingCompanyName }}
        />
      </Text>
      <Text component="p" m={0} size="sm" style={welcomeParagraphStyle}>
        {t("onboarding.welcome.checkInfo")}
      </Text>
    </Stack>
  )
}
